<div class="media-library-container">
  <!-- Banner Header -->
  <div class="dialog-banner">
    <mat-icon class="banner-icon">
      {{ state.mediaType === 'photos' ? 'photo_library' : 'video_library' }}
    </mat-icon>
    <div class="banner-text">
      <h2>{{ "COMPONENTS.MEDIA_LIBRARY.HEADER.TITLE" | translate }}</h2>
      <span>{{ "COMPONENTS.MEDIA_LIBRARY.HEADER.SUBTITLE" | translate }}</span>
    </div>
    <button mat-icon-button class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="divider"></div>

  <!-- Toolbar: media type toggle + selection actions -->
  <div class="toolbar">
    <div class="selection-actions left">
      <button
        mat-stroked-button
        class="delete-btn"
        *ngIf="selectedItems.length > 0"
        (click)="onDeleteSelected()"
      >
        <mat-icon>delete_outline</mat-icon>
        {{ "COMPONENTS.MEDIA_LIBRARY.HEADER.DELETE_SELECTED" | translate }}
      </button>
    </div>

    <mat-button-toggle-group
      class="media-toggle"
      [value]="state.mediaType"
      (change)="switchMediaType($event.value)"
      [disabled]="state.busy"
    >
      <mat-button-toggle value="photos">
        <mat-icon>photo</mat-icon>
        {{ "COMPONENTS.MEDIA_LIBRARY.HEADER.PHOTOS_RADIO" | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="videos">
        <mat-icon>videocam</mat-icon>
        {{ "COMPONENTS.MEDIA_LIBRARY.HEADER.VIDEOS_RADIO" | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>

    <div class="selection-actions right">
      <div class="selected-badge" *ngIf="selectedItems.length > 0">
        <span class="badge-count">{{ selectedItems?.length }}</span>
        <span class="badge-label">{{ "COMPONENTS.MEDIA_LIBRARY.HEADER.ITEMS_SELECTED" | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Body -->
  <div class="body-container">
    <div class="upload-panel" [ngSwitch]="state.mediaType">
      <cm-media-library-upload
        *ngSwitchCase="'photos'"
        [mediaType]="state.mediaType"
        (filesAdded)="onUploadFilesAdded($event)"
        (progress)="onUploadProgress($event)"
        (complete)="onUploadComplete($event)"
      ></cm-media-library-upload>
      <cm-media-library-upload
        *ngSwitchCase="'videos'"
        [mediaType]="state.mediaType"
        (filesAdded)="onUploadFilesAdded($event)"
        (progress)="onUploadProgress($event)"
        (complete)="onUploadComplete($event)"
      ></cm-media-library-upload>
    </div>

    <div
      class="media-grid-container"
      infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      [scrollWindow]="false"
      (scrolled)="getNextPage()"
    >
      <!-- Upload progress items + media items -->
      <div class="media-grid">
        <cm-media-library-image-upload
          [output]="output"
          *ngFor="let output of imageUploadOutputs"
        ></cm-media-library-image-upload>

        <cm-media-library-image
          *ngFor="let image of images"
          [image]="image"
          (selected)="onImageSelected($event)"
          (unselected)="onImageUnselected($event)"
        ></cm-media-library-image>

        <cm-media-library-video-upload
          [output]="output"
          *ngFor="let output of videoUploadOutputs"
        ></cm-media-library-video-upload>

        <cm-media-library-video
          *ngFor="let video of videos"
          [video]="video"
          (selected)="onVideoSelected($event)"
          (unselected)="onVideoUnselected($event)"
        ></cm-media-library-video>
      </div>

      <!-- Empty state -->
      <div
        class="empty-state"
        *ngIf="!state.busy && images.length === 0 && videos.length === 0 && imageUploadOutputs.length === 0 && videoUploadOutputs.length === 0"
      >
        <mat-icon class="empty-icon">
          {{ state.mediaType === 'photos' ? 'collections' : 'videocam_off' }}
        </mat-icon>
        <span class="empty-title">
          {{ (state.mediaType === 'photos'
            ? "COMPONENTS.MEDIA_LIBRARY.EMPTY.PHOTOS_TITLE"
            : "COMPONENTS.MEDIA_LIBRARY.EMPTY.VIDEOS_TITLE") | translate }}
        </span>
        <span class="empty-subtitle">
          {{ (state.mediaType === 'photos'
            ? "COMPONENTS.MEDIA_LIBRARY.EMPTY.PHOTOS_SUBTITLE"
            : "COMPONENTS.MEDIA_LIBRARY.EMPTY.VIDEOS_SUBTITLE") | translate }}
        </span>
      </div>

      <!-- Loading spinner -->
      <div class="loading-state" *ngIf="state.busy && images.length === 0 && videos.length === 0">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <button mat-stroked-button (click)="cancel()">
      {{ "COMPONENTS.MEDIA_LIBRARY.BUTTONS.CANCEL" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="addSelected()"
      [disabled]="selectedItems.length < 1"
    >
      {{ "COMPONENTS.MEDIA_LIBRARY.BUTTONS.ADD_SELECTED" | translate }}
    </button>
  </div>
</div>
